import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-cp-menu',
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ` <p>cp-menu works!</p> `,
  styles: ``,
})
export class CpMenuComponent {}
